module.exports = __webpack_public_path__ + "static/media/pessoa.63195534.svg";